import React from 'react';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select-plus';

const jobStatusOption = (jobStatus) => (
  <span>
    <FontAwesome name="square" style={{ color: jobStatus.color || '#fafafa' }} />
    {` ${jobStatus.status}`}
  </span>
);

const JobStatusDropdown = ({ jobStatuses, ...props }) => (
  <Select
    optionRenderer={jobStatusOption}
    options={jobStatuses}
    valueKey="value"
    valueRenderer={jobStatusOption}
    {...props}
  />
);

export default JobStatusDropdown;
